import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const usePerksNotifyCount = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/leads/perks-notify-count`)
      .then((res) => setCount(res.data?.count ?? 0))
      .catch(() => setCount(null));
  }, []);

  return count;
};
